/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * useCallDuration.ts — us\1 \2al\1 \2uration (services/operator-web-app).
 */

import { useState, useEffect } from 'react';
import { useCall } from '@/store';

/**
 * Returns call duration in seconds since connectedAt, or 0 when not connected.
 */
export function useCallDuration(): number {
  const call = useCall();
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (call.phase !== 'connected' || !call.connectedAt) {
      setSeconds(0);
      return;
    }
    const start = new Date(call.connectedAt).getTime();
    const tick = () => setSeconds(Math.max(0, Math.floor((Date.now() - start) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [call.phase, call.connectedAt]);

  return seconds;
}

export function formatCallDuration(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
